<template>
  <!-- (拟设)基金的直接股东/董事信息 -->
  <div>
    <!-- 编辑模式：添加按钮 + 列表 -->
    <template v-if="!isReadonly">
      <div class="pb20">
        <el-button type="primary" plain icon="el-icon-circle-plus-outline" @click="addHandle" class="fs12">{{ $t("enroll.intitle.addButton") }}</el-button>
        <info-popover placement="bottom" icon="el-icon-warning">
          <div class="linkWrap">
            <p class="fs12">{{ $t("enroll.intitle.caution") }}</p>
            <p class="pt2">
              <span class="fs12">{{ $t("common.reference") }}</span>
              <a href="https://www.acra.gov.sg/how-to-guides/setting-up-a-local-company/appointing-directors-company-secretary-and-other-key-personnel" target="_blank" class="lh14">
                https://www.acra.gov.sg/how-to-guides/setting-up-a-local-company/appointing-directors-company-secretary-and-other-key-personnel
              </a>
            </p>
          </div>
        </info-popover>
      </div>

      <div v-if="innerList.length != 0">
        <el-table :data="innerList | filtration" border class="wdb100">
          <el-table-column prop="positionHeld" :label="$t('enroll.questionnaire.proposalFundName')" align="center" min-width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.fundsInfo?.length > 0">{{ scope.row.fundsInfo.map(item => item.fundName).join(", ") }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="positionHeld" :label="$t('enroll.intitle.type')" align="center" min-width="100px">
            <template slot-scope="scope">
              <p>{{ getGlobalLabel("positionHeldTypeList", scope.row.positionHeld) }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="fullName" :label="$t('enroll.intitle.compellation')" align="center"></el-table-column>
          <el-table-column :label="$t('enroll.intitle.aggregate')" align="center" :formatter="summation"></el-table-column>
          <el-table-column :label="$t('common.operation')" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" class="mr6" @click="editHandle(scope.$index, scope.row)">{{ $t("common.button.edit") }}</el-button>
              <el-button type="text" icon="el-icon-delete" class="red" @click="deleteHandle(scope.$index, scope.row)">{{ $t("common.button.delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <p class="pt10 fs12 lh16 crgy919">{{ $t("enroll.intitle.suggest") }}</p>
    </template>

    <!-- 回显模式：直接平铺展示股东/董事详情 -->
    <template v-else>
      <div v-for="(row, index) in normalizedList" :key="`fundShareholderView-${index}`" class="viewCard">
        <p class="blueDark viewCardTitle">{{ getGlobalLabel("memberTypeList", row.memberType) }}</p>
        <div class="pt10 wdb100">
          <company-form-panel v-if="row.memberType === 'CORPORATE'" :form="row" :fundInfoList="fundInfoList" :isReadonly="true"></company-form-panel>
          <personal-form-panel v-else :form="row" :fundInfoList="fundInfoList" :isReadonly="true"></personal-form-panel>
        </div>
      </div>
      <p class="pt10 fs12 lh16 crgy919">{{ $t("enroll.intitle.suggest") }}</p>
    </template>

    <!-- 新建/编辑 - 弹窗(编辑模式专用) -->
    <add-or-update v-if="!isReadonly" ref="addOrUpdateRef" :fundInfoList="fundInfoList" @update="updateItem"></add-or-update>
  </div>
</template>

<script>
import { addition } from "@/utils/count";
import AddOrUpdate from "./modal/AddOrUpdate.vue";
import CompanyFormPanel from "./modal/CompanyFormPanel.vue";
import PersonalFormPanel from "./modal/PersonalFormPanel.vue";
import { normalizeCompanyForm, normalizePersonalForm } from "./modal/formFactory";
import InfoPopover from "@/components/InfoPopover";
import { mapState, mapGetters } from "vuex";

export default {
  name: "FundShareholderDirectorInformation",
  components: { AddOrUpdate, InfoPopover, CompanyFormPanel, PersonalFormPanel },
  props: {
    /** v-model 绑定值：基金的股东/董事信息数组 */
    value: { type: Array, default: () => [] },
    /** 基金信息列表（供弹窗选择关联基金） */
    fundInfoList: { type: Array, default: () => [] },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
    ...mapGetters("constant", ["getGlobalLabel"]),
    /** 内部列表，与 value 保持同步 */
    innerList() {
      return this.value || [];
    },
    /** 回显模式：归一化后的股东/董事列表(过滤名义董事 + 补全缺失字段，避免模板访问 undefined 报错) */
    normalizedList() {
      return (this.innerList || [])
        .filter(item => item.positionHeld != "NOMINEE_DIRECTOR")
        .map(row => (row.memberType === "CORPORATE" ? normalizeCompanyForm(row) : normalizePersonalForm(row)));
    },
  },
  filters: {
    // 过滤名义董事
    filtration(arr) {
      const newArr = arr.filter(item => item.positionHeld != "NOMINEE_DIRECTOR");
      return newArr;
    },
  },
  methods: {
    // 所占股份数量 - 求和
    summation(row) {
      const sharesInfo = row.sharesInfo;
      if (!sharesInfo || sharesInfo.length === 0) {
        return null;
      } else {
        let sum = 0;
        for (let i in sharesInfo) {
          sum = addition(sum, sharesInfo[i].quantityOfSharesAllotted);
        }
        return sum;
      }
    },
    /** 同步变更到父组件 */
    emitInput(newList) {
      this.$emit("input", newList);
    },
    // 新建
    addHandle() {
      this.$refs.addOrUpdateRef.init("add");
    },
    // 编辑
    editHandle(index, row) {
      this.$refs.addOrUpdateRef.init(index, row);
    },
    // 删除
    deleteHandle(index) {
      const list = [...this.innerList];
      list.splice(index, 1);
      this.emitInput(list);
    },
    // 更新（新增或编辑回调）
    updateItem(obj, index) {
      let list = JSON.parse(JSON.stringify(this.innerList));
      if (index === "add") {
        list.push(obj);
      } else {
        list.splice(index, 1, obj);
      }
      this.emitInput(list);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 回显模式 - 股东/董事详情卡片 */
.viewCard {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 0 20px 10px;
  margin-bottom: 20px;

  .viewCardTitle {
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    border-bottom: 1px solid #e4e7ed;
  }
}
</style>
